import {
  FieldError,
  Group,
  Label,
  Text,
  TextArea,
  TextField as TextFieldBase,
  type TextFieldProps as TextFieldBaseProps,
} from "react-aria-components";
import { useTranslation } from "react-i18next";
import { css, cx } from "../../../../styled-system/css";
import { formField } from "../../../../styled-system/recipes";
import type { ReactNode } from "react";

interface TextFieldProps extends TextFieldBaseProps {
  label?: ReactNode;
  description?: string;
  errorMessage?: string;
  className?: string;
  rows?: number;
  placeholder?: string;
  characterCount?: {
    show?: boolean;
    max?: number;
  };
}

export function TextAreaField({
  label,
  description,
  errorMessage,
  className,
  rows = 4,
  placeholder,
  characterCount,
  ...props
}: TextFieldProps) {
  const { t } = useTranslation(["common"]);
  const classes = formField({ override: "textarea" });
  const valueLength = typeof props.value === "string" ? props.value.length : 0;
  return (
    <TextFieldBase isInvalid={!!errorMessage} {...props} className={cx(classes.fieldWrapper, className)}>
      {label && <Label className={classes.label}>{label}</Label>}
      <Group className={classes.inputBox}>
        <TextArea className={classes.input} rows={rows} placeholder={placeholder} />
      </Group>
      <span className={css({ color: "gray", fontSize: "small", textAlign: "end" })}>
        {characterCount?.show &&
          (characterCount.max ?
            t(($) => $.common["{count} / {max} characters"], { count: valueLength, max: characterCount.max })
          : t(($) => $.common["{count} characters"], { count: valueLength }))}
      </span>
      {description && <Text slot="description">{description}</Text>}
      {errorMessage && <FieldError className={classes.error}>{errorMessage}</FieldError>}
    </TextFieldBase>
  );
}
